<button
  class="loren-help-button-container"
  [matTooltip]="'toolbar.help' | transloco"
  [tourAnchor]="helpAnchorId"
  (click)="handleHelpClick($event)">
  <button class="loren-help-button" [ngClass]="{ 'ml-2': isHandset }">
    <mat-icon class="loren-help-button-icon"> help </mat-icon>
  </button>
  @if(!isHandset) {
  <span class="loren-help-button-text">{{ "toolbar.help" | transloco }}</span>
  }
</button>
